// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../src/assets/fonts/NBInternationalProReg.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../src/assets/fonts/NBInternationalProBol.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../src/assets/fonts/NBInternationalProMono.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../node_modules/react-native-vector-icons/Fonts/MaterialIcons.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../node_modules/react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#app-root {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  font-synthesis: none !important; /* fix Safari font rendering issue */
}

@font-face {
  font-family: "NBInternationalProReg";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "NBInternationalProBol";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "NBInternationalProMono";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "MaterialIcons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "MaterialCommunityIcons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-weight: normal;
  font-style: normal;
}
`, "",{"version":3,"sources":["webpack://./web/main.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,+BAA+B,EAAE,oCAAoC;AACvE;;AAEA;EACE,oCAAoC;EACpC,4CAAyD;EACzD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,4CAAyD;EACzD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,4CAA0D;EAC1D,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,4CAA6E;EAC7E,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,4CAAsF;EACtF,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":["#app-root {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  font-synthesis: none !important; /* fix Safari font rendering issue */\n}\n\n@font-face {\n  font-family: \"NBInternationalProReg\";\n  src: url('../src/assets/fonts/NBInternationalProReg.ttf');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"NBInternationalProBol\";\n  src: url('../src/assets/fonts/NBInternationalProBol.ttf');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"NBInternationalProMono\";\n  src: url('../src/assets/fonts/NBInternationalProMono.ttf');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"MaterialIcons\";\n  src: url(\"../node_modules/react-native-vector-icons/Fonts/MaterialIcons.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"MaterialCommunityIcons\";\n  src: url(\"../node_modules/react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
